function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.478 17.073a2.172 2.172 0 01-.966-2.045 8.215 8.215 0 01.838-2.781 2.318 2.318 0 012.111-1.278h10.787a2.316 2.316 0 012.11 1.278 8.209 8.209 0 01.838 2.781 2.174 2.174 0 01-.965 2.045 13.649 13.649 0 01-7.376 1.747 13.643 13.643 0 01-7.377-1.747zM2.5 12.828a6.929 6.929 0 00-.708 2.312.86.86 0 00.362.823 12.45 12.45 0 006.7 1.549 12.437 12.437 0 006.7-1.549.863.863 0 00.363-.823 6.9 6.9 0 00-.708-2.312 1.035 1.035 0 00-.96-.55H3.462a1.037 1.037 0 00-.959.55zm1.858-7.747a4.539 4.539 0 014.5-4.58 4.539 4.539 0 014.5 4.58 4.539 4.539 0 01-4.5 4.58 4.539 4.539 0 01-4.5-4.581zm1.284 0a3.242 3.242 0 003.212 3.271 3.242 3.242 0 003.211-3.271A3.242 3.242 0 008.854 1.81a3.242 3.242 0 00-3.211 3.27z",
  strokeMiterlimit: 10
});

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.708 19.32",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgUser;